var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"user-add"},[_c('h3',{staticClass:"title is-3"},[_vm._v("Neuen Benutzer anlegen")]),_c('UserForm',{attrs:{"user":_vm.user},on:{"update:user":function($event){_vm.user=$event},"submit":_vm.dispatchAddUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }